import React from 'react';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import './uberConnect.css';

export default class UberConnectModal extends React.Component {
  state = {
    modalOpen: true,
    passwordShown: false,
  };

  handleClick = () => {
    this.setState({ passwordShown: !this.state.passwordShown });
  };

  render() {
    const { uberURL, username, password, message } = this.props;
    return (
      <Modal open={this.state.modalOpen}>
        <div className="uber-connect__container">
          {message ? null : (
            <p>
              <strong>Please follow these steps to link your Uber account to Autzu</strong>
            </p>
          )}
          {message === 'mismatch' ? (
            <div>
              <p>It seems like you have signed in with an account that is not associated with our fleet.</p>
              <p>
                Make sure you are signed out on{' '}
                <a target="_blank" rel="noopener noreferrer" href="https://help.uber.com">
                  <b>Uber's website</b>
                </a>
              </p>
            </div>
          ) : null}
          {message === 'duplicate' ? (
            <div>
              <p>
                The Uber account you have provided is already linked to an existing Autzu account.<br />
                Please contact customer support for more information or try again by doing the following:
              </p>
              <p>
                Make sure you are signed out on{' '}
                <a target="_blank" rel="noopener noreferrer" href="https://help.uber.com">
                  <b>Uber's website</b>
                </a>
              </p>
            </div>
          ) : null}
          {username ? (
            <div>
              <p>Sign in to your Uber account with the following login credentials:</p>
              <p>
                <strong>Uber email:</strong> {username}
              </p>
            </div>
          ) : null}
          {username && password ? (
            <p onClick={this.handleClick} role="presentation">
              <strong>Password:</strong> {this.state.passwordShown ? password : '(click to reveal)'}
            </p>
          ) : null}
          <a href={uberURL} style={{ display: 'flex', justifyContent: 'center' }}>
            <Button label="Connect with Uber" fullWidth />
          </a>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/User/UberConnectModal.js